import Vue from 'vue';
import { Component } from 'nuxt-property-decorator';
import { HotelDetail } from '~/schemes';

@Component({
  /**
   * @memo
   * Redirect only
   */
  async middleware({ redirect, $hotel, params, error }) {
    let hotel: HotelDetail | null | undefined = $hotel.current;
    if (!hotel) hotel = await $hotel.getBySlug(params.hotel_slug);
    if (!hotel) {
      return error({
        statusCode: 404,
      });
    }
    const redirectTo = $hotel.location(`/todo/1/`, hotel);
    redirect(redirectTo.path as string);
  },
})
export default class MyView extends Vue {}
